// src/components/practice/tasks/writing/layouts/GoetheFormalMessageLayout.jsx
import React from 'react';

const GoetheFormalMessageLayout = ({ guidingPoints, effectiveWordLimit }) => {
    return (
        <>
            {/* Guiding Points - 2x2 grid boxes */}
            {guidingPoints && guidingPoints.length > 0 && (
                <div className="my-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {guidingPoints.map((point, index) => (
                            <div
                                key={index}
                                className="border-2 border-gray-800 p-4 bg-white min-h-[80px] flex items-center"
                            >
                                <p className="text-gray-800 text-base leading-relaxed">
                                    {point.text || point}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Special instructions */}
            <div className="my-6 text-sm text-gray-700 leading-relaxed">
                <p className="mb-2">
                    Überlegen Sie sich eine passende Reihenfolge für die Inhaltspunkte.
                </p>
                <p>
                    Bei der Bewertung wird darauf geachtet, wie genau die Inhaltspunkte bearbeitet sind, wie korrekt der Text ist und wie gut
                    die Sätze und Abschnitte sprachlich miteinander verknüpft sind. Vergessen Sie nicht Anrede und Gruß. Schreiben Sie
                    mindestens <strong>{effectiveWordLimit?.min || 100} Wörter</strong>.
                </p>
            </div>
        </>
    );
};

export default GoetheFormalMessageLayout;